import { render, staticRenderFns } from "./TifRutasForm.vue?vue&type=template&id=b5e6c8fe"
import script from "./TifRutasForm.vue?vue&type=script&lang=js"
export * from "./TifRutasForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports